import Divider from './Divider';

// export types
export type { DividerProps } from './Divider';

// export components
export { Divider };
export default Divider;
